import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Activity, ListChecks, ShieldAlert, SlidersHorizontal } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchRiskDashboard, FRAUD_STR as S, type RiskActorRow } from './fraudApi'

/**
 * A25.01 — Риск-дашборд. Highest-risk actors, derived live from the REAL
 * `/admin/antifraud/events` feed (events grouped per user, highest score first).
 * Placeholder permission USERS_VIEW.
 */
export function RiskDashboardScreen() {
  const columns = useMemo<AdminColumn<RiskActorRow>[]>(
    () => [
      { key: 'user', header: S.actor, type: 'text' },
      { key: 'max_score', header: S.maxScore, type: 'risk' },
      { key: 'events', header: S.eventsCount, type: 'number' },
      { key: 'open', header: S.openCount, type: 'number' },
      { key: 'last_type', header: S.lastType, type: 'text' },
      { key: 'last_seen', header: S.created, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchRiskDashboard, [])
  return (
    <>
      <PageHeader
        title={S.riskDashboard}
        screenId="A25.01"
        actions={
          <div className="flex items-center gap-1.5">
            <Link
              to="/antifraud/events"
              className="inline-flex items-center gap-1.5 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:border-border-strong hover:text-primary"
            >
              <ShieldAlert size={13} />
              {S.events}
            </Link>
            <Link
              to="/antifraud/rules"
              className="inline-flex items-center gap-1.5 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:border-border-strong hover:text-primary"
            >
              <SlidersHorizontal size={13} />
              {S.rules}
            </Link>
            <Link
              to="/antifraud/blacklist"
              className="inline-flex items-center gap-1.5 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:border-border-strong hover:text-primary"
            >
              <ListChecks size={13} />
              {S.blacklist}
            </Link>
          </div>
        }
      />
      <DataTable<RiskActorRow>
        screenId="A25.01"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.user}
        exportable
        emptyState={{ icon: <Activity size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
